import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import * as R from "ramda";
import contriesList from "iso-3166-1-alpha-2";
import { addServiceData, updateServiceData, deleteServiceData } from "../../../../../actions/services-api";
import { generateLettersForUserIdAndUserServiceId } from "../../../../../actions/events-api";

import ServiceData from "../../../../../constants/models/serviceData";
import Generic from "../../../../../constants/models/servicePayloads/generic";
import { ConnectionTypes, convertConnectionTypesToServiceType } from "../../../../../constants/utils/connectionTypes";
import { useDispatch, useSelector } from "react-redux";
import * as Loadings from "../../../../../constants/loadings/service";
import { RegexFields } from "../../../../../constants/utils/regexFields";

import { PostalCityInput } from "../../../../../_common/postalCityInput";

export const CustomBox = ({ customServiceData, inputOnFocus, connectionType, boxIndex, setShowCustomBox, isActive, setSearchFilter, generateRelocationLetters }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const dispatch = useDispatch();
	const customFormRef = useRef(null);
	const user = useSelector((state) => state.user);
	const services = useSelector((state) => state.services);
	const [payloads, setPayloads] = useState({ items: [{ id: "", payload: new Generic({ reference: "", comment: "" }) }] });
	const [toDelete, setToDelete] = useState([]);
	const [autoFocus, setAutoFocus] = useState(false);
	const [isEditing, setIsEditing] = useState(R.isNil(customServiceData) ? true : false);

	function loadReferences() {
		let allServicesWithSameBranch = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && !R.isNil(customServiceData) ? services.serviceData[connectionType].filter((b) => b.serviceId === customServiceData.serviceId) : [];
		let tmpPayloads = { items: payloads.items.filter((i) => toDelete.findIndex((d) => d === i.id) === -1) };
		allServicesWithSameBranch.forEach((br) => {
			if (tmpPayloads.items.findIndex((tmp) => tmp.id === br.id) === -1) {
				tmpPayloads.items.push({ id: br.id, payload: br.payload });
			}
		});
		if (allServicesWithSameBranch.length > 0 && tmpPayloads.items.length > 0) {
			if (tmpPayloads.items[0].payload.reference === "") {
				tmpPayloads.items.splice(0, 1);
			}
			setPayloads(tmpPayloads);
		}
		setToDelete([]);
	}

	let customServiceDetails = R.isNil(customServiceData) ? null : customServiceData.customServiceDetails;
	if (R.isNil(customServiceDetails)) {
		customServiceDetails = {
			name: "",
			address: {
				streetAddress: "",
				streetAddress2: "",
				postalCode: "",
				addressLocality: "",
				addressCountry: "FR",
			},
		};
	}
	const [serviceDetails, setServiceDetails] = useState(customServiceDetails);

	useEffect(() => {
		loadReferences();
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		loadReferences();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [!R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType], !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].length]);

	let addressName =
		(!R.isNil(serviceDetails.address.streetAddress) ? serviceDetails.address.streetAddress : "") +
		(!R.isNil(serviceDetails.address.streetAddress2) ? " " + serviceDetails.address.streetAddress2 : "") +
		(!R.isNil(serviceDetails.address.streetAddress3) ? " " + serviceDetails.address.streetAddress3 : "") +
		(!R.isNil(serviceDetails.address.postalCode) && !R.isNil(serviceDetails.address.addressLocality) ? "," + serviceDetails.address.postalCode + " " + serviceDetails.address.addressLocality : "") +
		(!R.isNil(serviceDetails.address.addressCountry) ? ", " + countries.getName(serviceDetails.address.addressCountry, "fr", { select: "official" }) : "");

	let fieldName = "Référence";
	if (connectionType === ConnectionTypes.socialNetworks) {
		fieldName = "Nom d'utilisateur, adresse e-mail ou téléphone";
	} else if (connectionType === ConnectionTypes.homeService) {
		fieldName = "Référence ou nº CESU";
	} else if (connectionType === ConnectionTypes.multimedia) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.technology) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.music) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.poleEmploi) {
		fieldName = "Numéro d'adhérent";
	} else if (connectionType === ConnectionTypes.socialSecurity) {
		fieldName = "Numéro de Sécurité Sociale";
	} else if (connectionType === ConnectionTypes.caf) {
		fieldName = "Numéro de Sécurité Sociale";
	} else if (connectionType === ConnectionTypes.taxes) {
		fieldName = "Numéro fiscal";
	} 

	return (
		<form className={"card rounded border-dim align-self-center grid-column-4" + (isActive ? " shadow" : "") + (isEditing ? "" : " align-self-center flex-xl-row picker-card active")} noValidate ref={customFormRef} id="formCustom">
			{isEditing ? (
				<div className="card-header pt-3 pb-0">
					<div className="row gx-2">
						<div className="col-12 col-md-5">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"banque" + boxIndex}>
										{connectionType === ConnectionTypes.notary ? "Nom et Prénom" : "Nom du service"}
									</label>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="Le nom de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input
									pattern=".*\S+.*"
									type="text"
									className="form-control rounded"
									id={"banque" + boxIndex}
									required
									placeholder={connectionType === ConnectionTypes.notary ? 'Nom et Prénom' : 'Nom du service' }
									value={serviceDetails.name}
									onChange={(e) => setServiceDetails({ ...serviceDetails, name: e.target.value })}
								/>
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-7">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne1" + boxIndex}>
										Adresse ligne 1
									</label>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input
									pattern=".*\S+.*"
									type="text"
									className="form-control rounded"
									id={"Adresseligne1" + boxIndex}
									required
									placeholder="Adresse ligne 1"
									value={serviceDetails.address.streetAddress}
									onChange={(e) => setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, streetAddress: e.target.value } })}
								/>
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
							<div className="form-group">
								<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + boxIndex}>
									Adresse ligne 2
								</label>
								<input type="text" className="form-control rounded" id={"Adresseligne2" + boxIndex} placeholder="Adresse ligne 2" value={serviceDetails.address.streetAddress2} onChange={(e) => setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, streetAddress2: e.target.value } })} />
							</div>
							<div className="row g-2">
								<PostalCityInput
									postalCode={serviceDetails.address.postalCode}
									city={serviceDetails.address.addressLocality}
									onChange={(updatedAddress) => {
										setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } });
									}}
									hasWrapper={false}
									country={serviceDetails.address.addressCountry}
									customClasses={{ city: "form-group col", postalCode: "form-group col" }}
									postalCodePattern={serviceDetails.address.addressCountry === "FR" ? RegexFields.frenchZipCode : undefined}
								/>

								{/* <div className="form-group col">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Code" + boxIndex}>
										Code postal
									</label>
									<input
										type="text"
										className="form-control rounded"
										id={"Code" + boxIndex}
										required
										pattern={serviceDetails.address.addressCountry === "FR" ? RegexFields.frenchZipCode : undefined}
										placeholder="Code postal"
										value={serviceDetails.address.postalCode}
										onChange={(e) => setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, postalCode: e.target.value } })}
									/>

									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group col">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Ville" + boxIndex}>
										Ville
									</label>
									<input
										pattern=".*\S+.*"
										type="text"
										className="form-control rounded"
										id={"Ville" + boxIndex}
										required
										placeholder="Ville"
										value={serviceDetails.address.addressLocality}
										onChange={(e) => setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, addressLocality: e.target.value } })}
									/>

									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div> */}

								<div className="form-group col-12 col-sm col-xl">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Pays" + boxIndex}>
										Pays
									</label>
									<select className="custom-select" id={"Pays" + boxIndex} tabIndex={-98} defaultValue={serviceDetails.address.addressCountry} onChange={(e) => setServiceDetails({ ...serviceDetails, address: { ...serviceDetails.address, country: e.target.value, addressCountry: e.target.value } })}>
										{Object.keys(contriesList.getData()).map((country, idx) => {
											if (country === "FR") {
												return (
													<option key={idx} value={country} selected="selected">
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											} else {
												return (
													<option key={idx} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											}
										})}
									</select>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="card-header py-3 flex-xl-column text-center align-items-center col-xl-5">
					<h3 className={"h6 text-uppercase font-weight-bolder mw-100" + (R.isNil(serviceDetails.name) || serviceDetails.name.trim() === "" ? " my-auto" : " mt-auto")}>{serviceDetails.name}</h3>
					{!R.isNil(addressName) && addressName.trim() !== "" ? (
						<div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy">
							<i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i>
							<span className="o-70">{addressName}</span>
						</div>
					) : (
						""
					)}
				</div>
			)}
			<div className="card-body">
				<div className="form-block">
					{connectionType === ConnectionTypes.notary
						? ""
						: payloads.items.map((br, index) => {
								return (
									<div className="form-row">
										<div className="col form-group mb-xs">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label htmlFor={"reference" + index + "-" + boxIndex} className="label h6 lh-root font-weight-bold">
													{fieldName}
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<input
												required={true}
												autoFocus={inputOnFocus || (autoFocus && index === payloads.items.length - 1)}
												type="text"
												className="form-control rounded"
												id={"reference" + index + "-" + boxIndex}
												placeholder="xxxxxxxxxxx"
												aria-describedby="basic-addon2"
												value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.reference : ""}
												onChange={(e) => {
													e.preventDefault();
													let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

													let payloadIndex = tmpPayload.findIndex((p, idx) => idx === index);
													if (payloadIndex !== -1) {
														tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: e.target.value, comment: tmpPayload[payloadIndex].payload.comment }) };
													} else {
														tmpPayload.push({ id: "", payload: new Generic({ reference: e.target.value, comment: "" }) });
													}
													setPayloads({ ...payloads, items: tmpPayload });
												}}
											/>
										</div>
										<div className="col form-group mb-xs">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label htmlFor={"referenceComentaire" + index + "-" + boxIndex} className="label h6 lh-root font-weight-bold">
													Commentaire
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="Les cases commentaires sont personnelles (ne seront pas visibles par le référent), elles vous permettent d'ajouter des notes à vos services.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<div className="input-group mb-0">
												<input
													type="text"
													className="form-control rounded"
													id={"referenceComentaire" + index + "-" + boxIndex}
													placeholder="xxxxxxxxxxx"
													value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.comment : ""}
													onChange={(e) => {
														e.preventDefault();
														let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

														let payloadIndex = tmpPayload.findIndex((p, idx) => idx === index);
														if (payloadIndex !== -1) {
															tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: tmpPayload[payloadIndex].payload.reference, comment: e.target.value }) };
														} else {
															tmpPayload.push({ id: "", payload: new Generic({ reference: "", comment: e.target.value }) });
														}
														setPayloads({ ...payloads, items: tmpPayload });
													}}
												/>
												{(index === 0 ? br.payload.reference !== "" : true) ? (
													<span
														className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded"
														id="basic-addon2"
														onClick={(e) => {
															e.preventDefault();
															if (!R.isNil(br.id) && br.id !== "") {
																let tmpToDelete = toDelete.concat(br.id);
																setToDelete(tmpToDelete);
																dispatch(deleteServiceData(br.id, connectionType));
															}
															let newPayload = payloads.items.filter((p, idx) => idx !== index);
															if (newPayload.length === 0) {
																newPayload.push({ id: "", payload: new Generic({ reference: "", comment: "" }) });
															}
															setPayloads({ ...payloads, items: newPayload });
														}}>
														<i className="eva eva-trash-2-outline"></i>
													</span>
												) : (
													""
												)}
											</div>
										</div>
										<div className={"col invalid-feedback alert-danger alert"}>Champs invalide</div>
									</div>
								);
						  })}
					{connectionType === ConnectionTypes.notary ? (
						""
					) : (
						<button
							type="button"
							className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs"
							disabled={R.isNil(customServiceData) || R.isNil(customServiceData.serviceId) || customServiceData.serviceId === ""}
							onClick={(e) => {
								e.preventDefault();
								setPayloads({ ...payloads, items: payloads.items.concat({ id: "", payload: new Generic({ reference: "", comment: "" }) }) });
								setAutoFocus(true);
							}}>
							<i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
							<span className="btn-text aling-middle">Ajouter une autre référence</span>
						</button>
					)}
				</div>
				{isEditing ? <hr className="mt-1" /> : ""}
				<div className="form-footer">
					<button
						className={"btn btn-sm btn-alert-info border-none loading-btn" + ((R.isNil(customServiceData) && services.isLoading.includes(Loadings.ADD_NEW_SERVICE + "custom")) || (!R.isNil(customServiceData) && services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA + customServiceData.serviceId)) ? " show" : "")}
						disabled={(R.isNil(customServiceData) && services.isLoading.includes(Loadings.ADD_NEW_SERVICE + "custom")) || (!R.isNil(customServiceData) && services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA + customServiceData.serviceId))}
						onClick={(e) => {
							e.preventDefault();
							if (connectionType !== ConnectionTypes.notary) {
								customFormRef.current.classList.add("was-validated");
								if (customFormRef.current.checkValidity() || (payloads.items.length === 1 && payloads.items[0].payload.reference === "")) {
									payloads.items.length > 0 &&
										payloads.items.forEach((payload) => {
											let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: "custom", customServiceDetails: serviceDetails, payload: payload.payload, lifeEvent: 1 });
											if (!R.isNil(customServiceData) && !R.isNil(customServiceData.serviceId) && customServiceData.serviceId !== "") {
												serviceData.serviceId = customServiceData.serviceId;
											}
											if (R.isNil(payload.id) || payload.id === "") {
												dispatch(addServiceData(serviceData)).then((s) => {
													if (generateRelocationLetters) {
														dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
													}
												});
												setShowCustomBox(false);
											} else {
												serviceData.id = payload.id;
												dispatch(updateServiceData(serviceData)).then((s) => {
													if (generateRelocationLetters) {
														dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
													}
												});
											}
										});
									setPayloads({ payloads, items: payloads.items.filter((i) => i.id !== "") });
									setToDelete([]);
									if (!R.isNil(setSearchFilter)) {
										setSearchFilter([]);
									}
								}
							} else {
								//Notaire
								if (R.isNil(customServiceData) && (payloads.items[0].payload.reference === "" || R.isNil(payloads.items[0].payload.reference))) {
									payloads.items[0].payload.reference = "custom";
								}
								let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: "custom", customServiceDetails: serviceDetails, payload: payloads.items[0].payload, lifeEvent: payloads.items[0].payload.lifeEvent || 1 });
								if (R.isNil(customServiceData)) {
									dispatch(addServiceData(serviceData)).then((s) => {
										if (generateRelocationLetters) {
											dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
										}
									});
									setShowCustomBox(false);
								} else {
									serviceData.id = customServiceData.id;
									dispatch(updateServiceData(serviceData)).then((s) => {
										if (generateRelocationLetters) {
											dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
										}
									});
								}
								if (!R.isNil(setSearchFilter)) {
									setSearchFilter([]);
								}
							}
						}}>
						enregistrer
						<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
					</button>
					<button
						className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
						id="basic-addon2"
						onClick={(e) => {
							e.preventDefault();
							if (R.isNil(customServiceData)) {
								setShowCustomBox(false);
							} else {
								dispatch(deleteServiceData(customServiceData.id, connectionType));
							}
						}}>
						<i className="eva eva-trash-outline"></i>
					</button>
					<button
						className="btn btn-sm btn-icon px-xs btn-faded ml-1 border-nonefloat-right float-right"
						id="basic-addon2"
						disabled={R.isNil(customServiceData)}
						onClick={(e) => {
							e.preventDefault();
							setIsEditing(!isEditing);
						}}>
						<i className="eva eva-edit-outline"></i>
					</button>
				</div>
			</div>
		</form>
	);
};
